import { CreateListSortPropertyJoinProps } from '../../utility/types';
import { api } from '../configs/axiosConfigs';

export const createListSortPropertyJoin = async ({ listSortId, propertyId, requestBody }: CreateListSortPropertyJoinProps) => {
  return await api.post(`list-sorts/${listSortId}/property/${propertyId}`, requestBody);
};
